export const API_ENDPOINTS = {
  production: "https://api.coingecko.com/api/v3",
  staging: "https://www.coingecko.xyz/api/v3",
  development: "http://localhost:3000/api/v3"
};

export const stockChartOptions = elementId => ({
  time: { useUTC: false },
  chart: {
    backgroundColor: null,
    panning: false,
    marginTop: 50,
    renderTo: `${elementId}`
  },
  rangeSelector: {
    selected: 1
  },
  rangeSelector: {
    enabled: false
  },
  navigator: {
    enabled: false
  },
  scrollbar: {
    enabled: false
  },
  plotOptions: {
    line: {
      marker: {
        fillColor: "#0b62a4",
        lineColor: "#FFFFFF",
        lineWidth: 1
      },
      animation: false
    },
    column: {
      color: "#0b62a4",
      animation: false
    }
  },
  xAxis: {
    ordinal: false,
    labels: {
      style: {
        color: "#56b4e9"
      }
    }
  },
  exporting: {
    buttons: {
      contextButton: {
        y: -10
      }
    },
    chartOptions: {
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false
          }
        }
      }
    },
    fallbackToExportServer: false
  },
  credits: {
    enabled: false
  }
});

export default {
  API_ENDPOINTS
};



// WEBPACK FOOTER //
// ./app/assets/webpack/config.js